export const DailyListPage = () => {
  return <>DailyListPage</>;
};
